import type { DimensionKey } from '../../features/matching-poc/types';

export type Ga4ConsentStatus = 'granted' | 'denied' | 'pending';

export type Ga4Surface = 'results' | 'shared' | 'email';

export type Ga4Species = 'Dog' | 'Cat';

/** Registered GA4 custom events — see docs/ga4-property-setup.md */
export const GA4_EVENT_NAMES = {
  quizPageView: 'quiz_page_view',
  quizStart: 'quiz_start',
  quizComplete: 'quiz_complete',
  quizPreference: 'quiz_preference',
  matchAnimalImpression: 'match_animal_impression',
  profileLinkClick: 'profile_link_click',
  adoptionApplicationClick: 'adoption_application_click',
  shareResultsEmail: 'share_results_email',
  friendrDashboardView: 'friendr_dashboard_view',
  pageView: 'page_view',
} as const;

export type Ga4EventName =
  (typeof GA4_EVENT_NAMES)[keyof typeof GA4_EVENT_NAMES];

export type Ga4EventParams = {
  shelter_id?: string;
  species?: Ga4Species;
  animal_id?: string;
  dimension_key?: DimensionKey;
  detail_level?: number;
  importance?: string;
  rank?: number;
  match_percent?: number;
  match_count?: number;
  surface?: Ga4Surface;
  page_path?: string;
  tab?: string;
  scope?: string;
  match_results_id?: string;
};

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}
